import { ENVS } from '../consts';
import getEnvFromUrl from './getEnvFromUrl';

export function getAppEnv() {
  // eslint-disable-next-line no-undef
  return APP_ENV;
}

export function getLocalStorageEnv() {
  const STORAGE_ENV_KEY_NAME = 'env';
  try {
    return localStorage.getItem(STORAGE_ENV_KEY_NAME);
  } catch (e) {
    console.warn('env-config', 'Cannot read environment override from local storage');
  }
}

export function get(object, path, defaultVal) {
  const _path = Array.isArray(path) ? path : path.split('.').filter((i) => i.length);

  if (!_path.length) {
    return object;
  } else if (object === undefined) {
    return defaultVal;
  }

  return get(object[_path.shift()], _path, defaultVal);
}

export function getEnvTypeForNumberedEnvs(envName = '') {
  const INTERNAL_ENVS = [ENVS.STAGING, ENVS.NIGHTLY];

  return INTERNAL_ENVS.find((env) => envName.match(`-${env}\\d*`) || envName.match(`^${env}\\d*`));
}

export function getUrlEnv() {
  const envFromUrl = getEnvFromUrl();
  // if the envFromUrl is either equals to one of the env types or it's a numbered env e.g. staging7
  if (getEnvTypeForNumberedEnvs(envFromUrl) || Object.values(ENVS).find((env) => env === envFromUrl)) {
    return envFromUrl;
  }
}

export { default as replaceConfigEnvTemplate } from './replaceConfigEnvTemplate';
